export default __webpack_public_path__ + "static/media/709.27c79c2c.png";